<template>
  <div>
    <panel-header>
        <back-link slot="arrow">
            <panel-header-back-arrow />
        </back-link>
        <span slot="text">Гороскоп</span>
    </panel-header>

    <div class="row" v-if="! showingAdvertising">
      <div class="col-12">
        <div class="white-wrapper sign-header">
          <div class="row mt-2">
            <div class="col-12 d-flex justify-content-center flex-column">
              <div class="border-bottom">
                <h2 class="sign-title">{{ hs.getSignName(sign) }}</h2>
                <span class="sign-today">Гороскоп на {{ today }}</span>
              </div>
            </div>
            <div class="col-12">
              <transition name="fade">
                <div class="mt-3 mb-2 sign-description" v-if="sentences.length > 0 && requestError === null">
                  <p v-for="s in sentences" :key="s.length + Math.random()">{{ s }}</p>
                </div>
              </transition>
              <spinner class="mt-3" v-if="sentences.length === 0 && requestError === null" />

              <div v-if="requestError !== null">
                <p class="sign-error">Не удалось загрузить гороскоп. Попробуйте позже.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center mt-3" v-if="! isMobile">
        <back-link/>
      </div>
    </div>

    <!-- Плашка с рекламой -->
    <advertising @endShowingAdvertising="showingAdvertising = false"/>
  </div>
</template>

<script>
import {heightIFrame, today} from "@/lib/utils";
import stringHelper from "@/lib/string";
import horoscopeService from "@/services/horoscope";
import {store} from "@/store";
import config from "@/config";
import axios from "axios";
import client from "@/services/client";

import PanelHeader from "@/components/PanelHeader/PanelHeader";
import BackLink from "@/components/_Utlis/BackLink";
import Spinner from "@/components/_Utlis/Spinner";
import PanelHeaderBackArrow from "@/components/PanelHeader/PanelHeaderBackArrow";
import bridge from "@vkontakte/vk-bridge";
import Advertising from "../../components/_Utlis/Advertising";

const fallbackHoroscopeLoaders = {
  aquarius: () => import("../../../../store/horoscope/aquarius.json"),
  aries: () => import("../../../../store/horoscope/aries.json"),
  cancer: () => import("../../../../store/horoscope/cancer.json"),
  capricorn: () => import("../../../../store/horoscope/capricorn.json"),
  gemini: () => import("../../../../store/horoscope/gemini.json"),
  leo: () => import("../../../../store/horoscope/leo.json"),
  libra: () => import("../../../../store/horoscope/libra.json"),
  pisces: () => import("../../../../store/horoscope/pisces.json"),
  sagittarius: () => import("../../../../store/horoscope/sagittarius.json"),
  scorpio: () => import("../../../../store/horoscope/scorpio.json"),
  taurus: () => import("../../../../store/horoscope/taurus.json"),
  virgo: () => import("../../../../store/horoscope/virgo.json"),
};

export default {
  name: "HoroscopeShow",
  props: {
    "sign": {
      type: String,
      required: true,
    }
  },
  components: {
    Advertising,
    PanelHeaderBackArrow,
    Spinner,
    BackLink,
    PanelHeader,
  },
  data() {
    return {
      sentences: [],
      hs: horoscopeService,
      sh: stringHelper,
      requestError: null,

      showingAdvertising: true,
    }
  },
  created() {
    this.getHoroscope(this.sign);
  },
  mounted() {
    bridge.send("VKWebAppScroll", {"top": 0, "speed": 0});
  },
  updated() {
    heightIFrame();
  },
  methods: {
    setHoroscopeText(text) {
      this.sentences = this.sh.generateText(text);
      this.requestError = null;
    },
    async setFallbackHoroscope(sign) {
      const loadFallback = fallbackHoroscopeLoaders[sign];
      if (!loadFallback) {
        return false;
      }

      const module = await loadFallback();
      const horoscope = module.default || module;
      if (!horoscope || !horoscope.data) {
        return false;
      }

      this.setHoroscopeText(horoscope.data);
      return true;
    },
    async getHoroscope(sign) {
      if (! sign) return "";

      const hasFallback = await this.setFallbackHoroscope(sign);
      const endpoint = config["endpoint"] + "/api/horoscope/" + sign;

      axios.get(endpoint, { timeout: 10000 }).then((res) => {
        setTimeout(() => {
          this.setHoroscopeText(res["data"]["response"]["data"]);
        }, 300);
      }).catch((error) => {
        console.log(error);

        if (!hasFallback) {
          this.requestError = error;
        }
        switch (error.message) {
          case "Network Error":
            if (!hasFallback) {
              store.commit("setIsOffline", true);
            }
            break;
        }
      });
    },
  },
  computed: {
    today() {
      return today();
    },
    isMobile() {
      return client.isMobile();
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../scss/partials/transitions";

  .sign-title {
    font-weight: bold;
  }

  .sign-today {
    display: block;
    margin-bottom: 7px;
    font-weight: 600;
  }

  .sign-description {
    font-size: 16px;
  }

  .img-wrapper {
    width: 120px;
    height: 120px;

    & img {
      width: 100px;
      height: 100px;
    }

    @media (max-width: 600px) {
      width: 60px;
      height: 60px;

      & img {
        width: 50px;
        height: 50px;
      }
    }
  }

  .sign-error {
    text-align: center;
    margin: 7px 0;
    font-size: 12px;
  }
</style>
